import React from "react";
import "./GrantAccessRequest.less";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Toolbar,
  Typography
} from "@material-ui/core";
import commonLabels from "../../../constants/messageConstants";
import moment from "moment";
import { apiPost } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import { ShowToast, toastType } from "../../../utils/toast-service";
import GuidelineFile from "./GuidelineFile";
import ThankYouAndPatience from "./ThankYouAndPatience";
import SignaturePopup from "./SignaturePopup";

export default class BrrRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: true,
      openBrrGuidelineDialog: false,
      openSignBrrDialog: false,
      successDialog: false,
      isContinueBiometric: false
    };
  }

  static getDerivedStateFromProps() {}

  /**
   * open signature dialog
   */
  openSignatureDialog = () => {
    this.setState({ openSignBrrDialog: true, openBrrGuidelineDialog: false });
  };

  /**
   * open and hide loader
   * @param {*} e 
   */
  handleLoader = e => {
    const { handleLoader } = this.props;
    handleLoader(e);
  };

  /** data conversion to blob format */
  dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const bb = new Blob([ab]);
    return bb;
  }

  /** Upload file to database */
  uploadFileToDb = sign => {
    const { visitorData , biometrics} = this.props;
    const requestBody = new FormData();
    requestBody.append("RequestId", visitorData?.RequestId || "");
    requestBody.append(
      "SigningDate",
      new Date(moment().format("MM/DD/YYYY hh:mm:ss")).toUTCString()
    );
    requestBody.append("IsSignedDocument", true);
    requestBody.append("SignerEmail", visitorData?.RequestedForEmail);
    requestBody.append("EnvelopId", null);
    requestBody.append("IsBiometric", (biometrics || []).length > 0);
    requestBody.append(
      "Signature",
      this.dataURItoBlob(sign.src ? sign.src : sign),
      "sign.png"
    );

    this.handleLoader(true);
    this.onSubmit(requestBody);
  };

  /** call on submit button */
  onSubmit = data => {
    apiPost({
      url: API_URL.request.UpdateABRFSigningDetails,
      postBody: data
    }).then(({ success: isExecuted }) => {
      const { visitorData, biometrics, setRequestDetails } = this.props;
      if (isExecuted == true) {
        ShowToast("Record updated successfully", toastType.SUCCESS, 5000, 200);
        this.setState({
          openSignBrrDialog: false,
          openBrrGuidelineDialog: false,
          successDialog: (biometrics || []).length <= 0,
          isContinueBiometric: (biometrics || []).length > 0
        });
      } else {
        ShowToast(
          commonLabels.somethingWrong.message,
          toastType.ERROR,
          5000,
          commonLabels.somethingWrong.code
        );
      }
      
      this.handleLoader(false);
      if ((biometrics || []).length <= 0) {
        setRequestDetails(visitorData, biometrics); 
      }
    });
  };

  /**
   * call on handle BRR
   * @param {*} e 
   */
  handleBrr(e) {
    if (e) {
      this.setState({ openDialog: false, openSignBrrDialog: true });
    } else this.setState({ openDialog: false, openBrrGuidelineDialog: true });
  }

  /**
   * call on close popup
   */

  clickOnClose =() => {
    this.setState({
        openBrrGuidelineDialog: false,
        openDialog: true
      });
  }

  /**
   * close signature popup
   */
  closeSignaturePopup = () => {
    this.setState({
      openSignBrrDialog: false,
      openDialog: true
      });
  }

  /**
   * click on ok button
   */
  biometricPopup = () => {
    const { visitorData, biometrics, setRequestDetails } = this.props;
    this.setState({
      isContinueBiometric: false
    }, ()=> {
      visitorData.IsSignedDocument =  (biometrics || []).length <= 0 ? false : true;
      setRequestDetails(visitorData, biometrics); 
    });
  }

  render() {
    const {
      openDialog,
      openSignBrrDialog,
      openBrrGuidelineDialog,
      successDialog,
      isContinueBiometric
    } = this.state;
    const { visitorData } = this.props;
    return (
      <>
        <div className={"col-xs-12 abrf-request-container"}>
          {openDialog && (
            <div>
              <div className={"col-xs-12"}>
                <span className={"span-brr-label"}>
                  {commonLabels.enableBrrSectionMessage.message}
                </span>
              </div>
              <div className={"row"}>
                <div className={"col-xs-12 end-xs req-btn"}>
                  <Button
                    autoFocus
                    onClick={() => this.handleBrr(true)}
                    variant={"contained"}
                  >
                    {"Yes\r"}
                  </Button>
                  <Button
                    autoFocus
                    onClick={() => this.handleBrr(false)}
                    variant={"contained"}
                  >
                    {"No\r"}
                  </Button>
                </div>
              </div>
            </div>
          )}
          {openSignBrrDialog && (
            <SignaturePopup
              closeSignaturePopup={this.closeSignaturePopup}
              openSignDialog={openSignBrrDialog}
              uploadFileToDb={this.uploadFileToDb}
              visitorData={visitorData}
            />
          )}
          {openBrrGuidelineDialog && (
            <GuidelineFile 
                openGuideline={openBrrGuidelineDialog}
                guidelineHeader={"Please read BRR Guidelines before you submit.\r"}
                openSignatureDialog={this.openSignatureDialog}
                clickOnClose={this.clickOnClose}
                pdfUrl={"public/releases/grantAccessRequest/BRR_Rules.pdf#zoom=100"}
                pdfHeader={"Building Rules & Regulations "}
                height={"25070px"}
                agreeText={"I agree to abide by all Building Rules and Regulations defined in the \"SDC Tech-ISMS Building Rules and Regulations Handbook.\""}
            />
          )}
        </div>

        {successDialog && (
          <ThankYouAndPatience
            successDialog={successDialog}
          />
        )}

        {isContinueBiometric &&
          <Dialog
              open={isContinueBiometric}
              aria-labelledby={"responsive-dialog-title"}
              maxWidth={"lg"}
          >
            <AppBar
                    style={{
                        position: "relative",
                        backgroundColor: "#064473",
                        height: "37px"
                    }}
            >
                <Toolbar>
                    <Typography
                        variant={"h6"}
                        style={{
                            textAlign: "center",
                            flex: "1",
                            marginBottom: "9px"
                        }}
                    >
                      {"Next Section\r"}
                    </Typography>
                </Toolbar>
            </AppBar>
            <DialogContent>
              <DialogContentText>
                <h1>
                <i>
                  <b>
                  {" "}
                  {"Please complete Biometric Form section."}
                  </b>
                </i>
                </h1>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <div className={"row"}>
                <div className={"col-xs-12 end-xs req-btn"}>
                <Button
                  onClick={() => {
                    this.biometricPopup();
                  }}
                  variant={"contained"}
                >
                  {"Ok\r"}
                </Button>
                </div>
              </div>
            </DialogActions>
          </Dialog>    }
      </>
    );
  }
}
